module.exports = __webpack_public_path__ + "static/devops-benefits-fc27a6cf701560b1e3c6109ced3ad1c2.mp4";